export default __webpack_public_path__ + "static/media/glasses-cool.297789c5.jpg";